import styled, { css, keyframes } from 'styled-components';

export const getDefaultStrokeColor = (color, value, err) => {
  const map = {
    red: '#db2828',
    yellow: '#fbbd08',
    green: '#21ba45',
  };

  if (color !== '') {
    console.log('getStrokeColor', { color, value, err });
  }

  if (color !== '') return color;
  if (err) return map['red'];
  if (Number(value) === 0) return '';
  if (Number(value) < 100) return map['yellow'];
  if (Number(value) === 100) return map['green'];
};

const progress = keyframes`
  0% {
    stroke-dasharray: ${({ percent }) => percent} 100;
  }
`;

export const CircleForeground = styled.path`
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  animation: ${progress} 1s ease-out forwards;
  stroke: ${({ strokeColor }) => strokeColor};
`;

export const CircleBackground = styled.path`
  ${({ bgColor }) => css`
    fill: none;
    stroke: ${bgColor};
    stroke-width: 3.8;
  `}
`;

export const ChartText = styled.text`
  ${({ color }) => css`
    fill: ${color};
    font-family: sans-serif;
    font-size: 0.4em;
    text-anchor: middle;
  `}
`;

export const CircleChart = styled.svg`
  ${({ size }) => css`
    display: block;
    margin: 10px auto;
    width: ${size};
    height: ${size};
  `}
`;

export const ChartContainer = styled.div`
  cursor: pointer;
`;
